import type { ReactNode } from "react";
import { IconChevronDown, IconChevronRight } from "./icons";

export interface DisclosureProps {
  labelWhenClosed: string;
  labelWhenOpen: string;
  open: boolean;
  onToggle: () => void;
  children?: ReactNode;
  labelClassName?: string;
}

export const Disclosure = ({
  labelWhenClosed,
  labelWhenOpen,
  open,
  onToggle,
  children,
  labelClassName,
}: DisclosureProps) => (
  <>
    <button
      type="button"
      onClick={onToggle}
      className={`font-semibold flex items-center cursor-pointer text-left py-2${labelClassName ? ` ${labelClassName}` : ""}`}
      aria-expanded={open}
    >
      {open ? (
        <IconChevronDown className="shrink-0" />
      ) : (
        <IconChevronRight className="shrink-0" />
      )}
      <span className="ml-0.5">{open ? labelWhenOpen : labelWhenClosed}</span>
    </button>
    {open && children != null ? children : null}
  </>
);
